const goldenYellow = {
    50: '#ffefc4',
    100: '#ffe49b',
    200: '#ffdd7d',
    300: '#ffd76a',
    400: '#ffcb3e',
}
export default goldenYellow;
